import React from 'react'
import './AthleteSummary.css'

var athleteClass = 0
var athleteGpa = null
var athleteJersey = null

const AthleteSearchSummary = (props) => {

    const athlete = props.athleteSearch

    var athletePositions = athlete.primaryPosition

    athleteClass = athlete.class

    const athleteSat = athlete.sat
    const athleteAct = athlete.act
    const athleteCommitted = athlete.committed

    if (Number.isInteger(athlete.gpa)) {
        // gpa does NOT have decimal
        athleteGpa = athlete.gpa.toFixed(1)
      } else {
        // gpa HAS decimal
        athleteGpa = athlete.gpa
      }

    var thumbnail = null
    var classPosition = null
    var athleteAcademics = ''

    var schoolLogo = null

    if (athleteGpa > 0) {
        athleteAcademics = 'GPA ' + athleteGpa
    } else {
        athleteAcademics = 'GPA'
    }

    if (athleteSat > 0) {
        athleteAcademics = athleteAcademics + ', SAT ' + athleteSat
    } else {
        athleteAcademics = athleteAcademics + ', SAT'
    }

    if (athleteAct > 0) {
        athleteAcademics = athleteAcademics + ', ACT ' + athleteAct
    } else {
        athleteAcademics = athleteAcademics + ', ACT'
    }

    // display Short Stop as Shortstop

    var primaryPosition = null
    var secondaryPosition = null

    if (athlete.primaryPosition === 'Short Stop') {

        primaryPosition = 'Shortstop'

    } else {

        primaryPosition = athlete.primaryPosition
    }

    if (athlete.secondaryPosition === 'Short Stop') {

        secondaryPosition = 'Shortstop'

    } else {

        secondaryPosition = athlete.secondaryPosition
    }

    if (athlete.secondaryPosition !== 'None' && athlete.secondaryPosition !== '') {
        athletePositions = primaryPosition + ', ' + secondaryPosition
    } else {
        athletePositions = primaryPosition
    }

    if (athlete.thumbnail !== 'None') {
        thumbnail = <img src={athlete.thumbnail} alt="Athlete Thumbnail"/>
    } else {
        thumbnail = <img src={require('../../images/user.svg').default} alt="User Icon"/>
    }

    if (athlete.primaryPosition !== 'None' && athlete.primaryPosition !== '') {
        classPosition = <h5>Class of {athleteClass}, {athletePositions}</h5>
    } else {
        classPosition = <h5>Class of {athleteClass}</h5>
    }

    if (athlete.jersey && athlete.jersey !== 'None') {
        athleteJersey = '#' + athlete.jersey
    } else {
        athleteJersey = null
    }

    if (props.athleteSchoolLogo && props.athleteSchoolLogo !== null && athlete.committedSchoolId !== 'K3tyNyEJzpifALwIUC1F') {
        schoolLogo = <img src={props.athleteSchoolLogo} alt="School Logo"/>
    } else {
        schoolLogo = <img src={require('../../images/committedBadge.svg').default} alt="Committed"/>
    }

    if (athleteCommitted) {
        return (
            <div className="AthleteRow">
                    <div className="AthleteDetailsContainer">
                        <div className="AthleteDetails">
                            <div className="AthleteName">
                                <h3>{athlete.firstName} {athlete.lastName} {athleteJersey}</h3>
                            </div>
                            <p>{athlete.clubTeamName}</p>
                            {classPosition}
                            <div className="AthleteAcademics">
                                <h4>COMMITTED</h4>
                                {schoolLogo}
                            </div>
                        </div>
                    </div>
                    <div className="AthleteThumbnailContainer">
                        {thumbnail}
                    </div>
                </div>
        )
    } else {
        return (
            <div className="AthleteRow">
                    <div className="AthleteDetailsContainer">
                        <div className="AthleteDetails">
                            <div className="AthleteName">
                                <h3>{athlete.firstName} {athlete.lastName} {athleteJersey}</h3>
                            </div>
                            <p>{athlete.clubTeamName}</p>
                            {classPosition}
                            <h6>{athleteAcademics}</h6>
                        </div>
                    </div>
                    <div className="AthleteThumbnailContainer">
                        {thumbnail}
                    </div>
                </div>
        )
    }  
}

export default AthleteSearchSummary